export default __webpack_public_path__ + "static/media/CNo.66-2.a83d35a6.jpg";